import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  IBillingAccountInfo,
  IBillingConsumeCost,
  ICostOverview,
} from '../../model/billing-center';
import { BILLING_PROXY_EDIT, BILLING_PROXY_VIEW } from '../config';
import { assignStudioQuery } from './order';

// 账户余额获取
export const getAccountInfo = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_VIEW}/api/account/info`);
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
      });

      const res = await parsedResponse<IBillingAccountInfo>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getAccountInfo', error);
      return null;
    }
  });

// 消费记录-（消费支出，近12月消费） YYYY-MM-DD
export const getConsumeCost = (
  studioId: string,
  startDate: string,
  endDate: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_VIEW}/api/consume/cost`);
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        start_date: startDate,
        end_date: endDate,
      });
      const res = await parsedResponse<IBillingConsumeCost[]>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getConsumeCost', error);
      return null;
    }
  });

// 费用总览-查询入账以及支出情况 YYYY-MM
export const getCostOverviewInfo = (
  studioId: string,
  startDate: string,
  endDate: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/consume/cost_overview`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        start_date: startDate,
        end_date: endDate,
      });

      const res = await parsedResponse<ICostOverview[]>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getCostOverviewInfo', error);
      return null;
    }
  });

export const setBalanceWarn = (data: {
  studio_id: string;
  alarm_balance: number;
  alarm_receiver: string;
}) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_EDIT}/api/account/account_alarm`
      );
      const response = await api.commonRequest('POST', url, data);
      return response;
    } catch (error) {
      console.log('failed: setBalanceWarn', error);
      return;
    }
  });
